import React from "react";

const Header = () => {
  return (
    <header>
      <div className="text-center py-5 my-5">
        <h2 className="fs-28">Export Quality</h2>
        <h3 className="fs-56 lh-64 gilroy-bold py-4">
          Grower, Producer & Processor
        </h3>
        <h4 className="fs-28 text-uppercase gilroy-bold">
          OF FRUITS & VEGETABLES
        </h4>
      </div>
    </header>
  );
};

export default Header;
